import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick?: () => void;
  loading: boolean;
};

export const AddButton: FC<Props> = ({ onClick, loading }) => {
  const { t } = useTranslation();

  return (
    <AppButton className={styles["add-button"]} onClick={onClick} type="dashed" disabled={loading}>
      + {t("contactsPage.generalInfo.newTag")}
    </AppButton>
  );
};
